import styled from 'styled-components';
import { QUALITY_MARK_ASPECT_RATIO, breakpoints } from 'config/config';

export const StyledListingDetailPage = styled('div')`
  .container {
    max-width: ${breakpoints.lg}px;
    margin: 0 auto;
    padding: 40px 24px 0;
  }

  .container-content {
    max-width: ${breakpoints.lg}px;
    margin: 0 auto;
    padding: 18px 24px 40px 24px;
  }

  .listing-detail-header {
    width: 100%;

    .anticon {
      margin-left: 5px;
      color: ${(props) => props.theme.manslauksZils};
    }

    .product-name-and-qmarks-container {
      max-width: ${breakpoints.lg}px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      flex-wrap: nowrap;
    }

    .product-name {
      white-space: normal;
    }

    .right-content {
      flex-direction: row;
      align-items: flex-start;
      white-space: nowrap;
    }
  }

  .listing-description-row {
    display: flex;
    align-items: baseline;
    margin-bottom: 16px;

    .description-label {
      font-size: 14px;
      font-weight: 500;
      color: ${({ theme }) => theme.grey};
      flex: 0 0 15%;
    }

    .description-text {
      font-size: 14px;
      color: ${({ theme }) => theme.colorText};
      line-height: 20px;
      flex: 0 0 85%;
    }
  }

  .listing-content {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 32px;

    .edited-row {
      .edited-text {
        font-size: 14px;
        font-style: italic;
        color: ${({ theme }) => theme.grey};
      }
    }

    .info-and-actions {
      display: flex;
      gap: 24px;
      align-items: flex-start;

      .info-rows {
        flex: 0 0 75%;
        display: flex;
        flex-direction: column;
        gap: 8px;

        .transaction-type-row {
          display: flex;
          align-items: baseline;

          .type-label {
            font-size: 14px;
            font-weight: 500;
            color: ${({ theme }) => theme.grey};
            flex: 0 0 20%;
          }

          .type-content {
            font-size: 14px;
            color: ${({ theme }) => theme.colorText};
            line-height: 20px;
            flex: 0 0 80%;
          }
        }

        .delivery-row,
        .farm-row {
          display: flex;
          align-items: baseline;

          .delivery-label,
          .farm-label {
            font-size: 14px;
            font-weight: 500;
            color: ${({ theme }) => theme.grey};
            flex: 0 0 20%;
          }

          .delivery-text,
          .farm-text {
            font-size: 14px;
            color: ${({ theme }) => theme.colorText};
            line-height: 20px;
            flex: 0 0 80%;
          }
        }
      }

      .actions-column {
        display: flex;
        margin-left: auto;
        flex-direction: column;
        gap: 10px;
        align-items: flex-end;

        .open-listing-button {
          margin-top: 10px;
          min-height: 55px;
        }

        .send-message-link {
          font-size: 14px;
          font-weight: 500;
          color: ${({ theme }) => theme.brand01};
          text-decoration: none;
          display: flex;
          align-items: center;
          align-self: center;
          margin: 0;
          padding: 0;
          height: auto;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .mobile-detail-header {
    display: none;
  }

  .listing-tabs {
    margin-top: 32px;

    .ratings-tab-label {
      display: flex;
      align-items: center;
      gap: 8px;

      .ant-rate {
        font-size: 14px;
      }
    }

    .ant-tabs {
      .ant-tabs-tab {
        .ant-tabs-tab-btn {
          color: ${({ theme }) => theme.grey}; /* inactive */
          transition: color 0.2s ease;
        }

        &:hover .ant-tabs-tab-btn {
          color: ${({ theme }) => theme.black};
        }
      }

      .ant-tabs-tab-active {
        .ant-tabs-tab-btn {
          color: ${({ theme }) => theme.black} !important;
        }
      }

      .ant-tabs-ink-bar {
        background: ${({ theme }) => theme.black} !important;
      }
    }

    .product-name-with-marks {
      display: flex;
      align-items: center;
      gap: 8px;

      .quality-marks-cell {
        display: flex;
        flex-wrap: wrap;
        gap: 4px;
        align-items: center;

        .quality-mark {
          width: 20px;
          aspect-ratio: ${QUALITY_MARK_ASPECT_RATIO};

          .ant-image {
            display: flex;
            width: 100%;
            height: 100%;

            img {
              object-fit: contain;
            }
          }
        }
      }
    }

    .contract-section {
      margin-bottom: 24px;

      h3 {
        font-size: 18px;
        font-weight: 600;
        color: ${({ theme }) => theme.colorText};
        margin-bottom: 12px;
      }

      p {
        font-size: 14px;
        color: ${({ theme }) => theme.colorText};
        line-height: 22px;
        white-space: pre-wrap;
      }

      .download-link {
        font-size: 14px;
        color: ${({ theme }) => theme.brand01};
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .delivery-condition-section {
      margin-bottom: 32px;

      .delivery-divider {
        height: 1px;
        background-color: ${({ theme }) => theme.borderColor};
        margin: 24px 0;
      }

      .delivery-date-range,
      .delivery-address,
      .delivery-description {
        color: ${({ theme }) => theme.colorText};

        strong {
          font-weight: 600;
          margin-right: 8px;
        }
      }

      .ant-table-wrapper {
        margin-top: 16px;
      }
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .mobile-detail-header {
      display: block;
      padding: 16px;

      .mobile-back {
        display: flex;
        align-items: center;
        gap: 4px;
        padding-bottom: 12px;
        cursor: pointer;

        .back-icon,
        img {
          width: 17px;
          height: 17px;
        }

        .back-text {
          font-size: 0.875rem;
          line-height: 16px;
          color: ${({ theme }) => theme.colorText};
        }
      }

      .mobile-title {
        font-size: 18px;
        font-weight: 600;
        color: ${({ theme }) => theme.colorText};
        margin: 12px 0 8px;
      }

      .identifier-row {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;

        .identifier {
          font-size: 14px;
          color: ${({ theme }) => theme.colorText};
        }
      }

      .actions-row {
        display: flex;
        gap: 10px;

        .send-message-btn {
          flex: 0 0 40%;
        }

        .apply-btn {
          flex: 0 0 56%;
        }

        .send-message-btn,
        .apply-btn {
          height: 44px;
          border-radius: 20px;
          font-size: 14px;
        }

        .apply-btn {
          background-color: ${({ theme }) => theme.wholesale};
          color: ${({ theme }) => theme.white};
          border-color: ${({ theme }) => theme.wholesale};
        }

        .send-message-btn {
          background-color: transparent;
          border: 1px solid ${({ theme }) => theme.wholesale};
          color: ${({ theme }) => theme.wholesale};
        }
      }
    }

    .container-content {
      padding: 16px;

      .listing-description-row {
        flex-direction: column;
        gap: 4px;

        .description-label,
        .description-text {
          flex: none;
          font-size: 16px;
        }
      }

      .description-divider {
        display: none;
      }

      .listing-content {
        gap: 0;
        .info-and-actions {
          flex-direction: column;

          .info-rows {
            flex: none;
            width: 100%;

            .transaction-type-row,
            .delivery-row,
            .farm-row {
              flex-direction: column;
              gap: 4px;
              padding: 12px 0;
              border-top: 1px solid ${({ theme }) => theme.borderBottom};

              .type-label,
              .delivery-label,
              .farm-label {
                flex: none;
                font-size: 16px;
              }

              .type-content,
              .delivery-text,
              .farm-text {
                flex: none;
                font-size: 16px;
                font-weight: 500;
              }
            }
          }

          .actions-column {
            display: none;
          }
        }
      }

      .listing-tabs {
        margin-top: 16px;

        .ant-tabs {
          .ant-tabs-nav {
            &::before {
              display: none;
            }
          }

          .ant-tabs-ink-bar {
            display: none;
          }

          .ant-tabs-tab {
            border: 1px solid ${({ theme }) => theme.grey};
            border-radius: 20px;
            padding: 6px 16px;
            margin: 0 4px;
            background: transparent;

            .ant-tabs-tab-btn {
              color: ${({ theme }) => theme.grey};
              font-size: 14px;
            }

            &:hover .ant-tabs-tab-btn {
              color: ${({ theme }) => theme.wholesale};
            }
          }

          .ant-tabs-tab-active {
            border-color: ${({ theme }) => theme.wholesale};

            .ant-tabs-tab-btn {
              color: ${({ theme }) => theme.wholesale} !important;
            }
          }
        }
      }
    }
  }
`;
